import { createFileRoute } from '@tanstack/react-router';
import { QuizResultPage } from '../../../../features/community-hub/components/quiz-result-page';

/**
 * Community Hub - Quiz Result Route
 * Path: /community-hub/attempts/:id
 *
 * Shows quiz attempt results with score, correct/incorrect answers, and explanations
 * User can see if they passed/failed and review their answers
 */
export const Route = createFileRoute('/_protected/community-hub/attempts/$id')({
  component: QuizResultPage,
});
